export default {
  GET_LIST: '/auth/user/myDocumentRequests'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/documentRequest.js